import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=57617a8b"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports